import React, { useEffect, useState } from "react";
import { getAllActive, readWithPayload } from "../../../Infrastructure/Services/DataService";
import { getWithExpiry } from "../../../Domain/Helpers/LocalStorageHelper";
import { formatArrayForSelectInput } from "../../../Domain/Helpers/SelectInputHelper";
import { inputType } from "../../../Domain/Constants/InputType";
import GenericInsertUpdatePage from "../../../Domain/Components/Functional/GenericInsertPage/GenericInsertPage";
import { toast } from "react-toastify";

function CampaignOperatorGameInsertPage(props) {
    const [campaign, setCampaign] = useState([]);
    const [operatorGameConfig, setOperatorGameConfig] = useState([]);
    const [operatorGameSearch, setOperatorGameSearch] = useState("");
    const [inputs, setInputs] = useState([]);

    useEffect(() => {
        const token = getWithExpiry("token");

        if (token === null) {
            props.setLoggedIn(false);
            return;
        }

        getAllActive("campaign/read", token)
            .then((data) => setCampaign(Array.isArray(data) ? data : []))
            .catch((ex) => toast.error(ex));
    }, []);

    const searchOperatorGameConfig = () => {
        const token = getWithExpiry("token");

        if (token === null) {
            props.setLoggedIn(false);
            return;
        }

        const search = operatorGameSearch.trim();

        if (search.length < 2) {
            toast.error("Type at least 2 characters");
            return;
        }

        readWithPayload("operator-game-config/read", token, {
            offset: 0,
            limit: 50,
            order: "asc",
            columnName: "id",
            relations: [],
            searchValues: {
                internal_game_id: search
            },
            searchRelations: {},
            values: {
                is_active: "1"
            },
            columns: ["id", "internal_game_id"]
        })
            .then((data) => {
                setOperatorGameConfig(Array.isArray(data) ? data : []);
            })
            .catch((ex) => toast.error(ex));
    };

    useEffect(() => {
        setInputs([
            {
                inputType: inputType.SELECT,
                labelText: "Campaign",
                required: true,
                inputId: "campaign_id",
                validationFunction: () => null,
                selectOptions: formatArrayForSelectInput(campaign, "name")
            },
            {
                inputType: inputType.SELECT,
                labelText: "OperatorGameConfig",
                required: true,
                inputId: "operator_game_config_id",
                validationFunction: () => null,
                selectOptions: formatArrayForSelectInput(operatorGameConfig, "internal_game_id")
            }
        ]);
    }, [campaign, operatorGameConfig]);

    return (
        <>
            <div style={{
                width: "593px",
                margin: "24px auto 0 auto"
            }}>
                <label style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "18px"
                }}>
                    Search OperatorGameConfig
                </label>

                <div style={{ display: "flex", gap: "10px" }}>
                    <input
                        type="text"
                        value={operatorGameSearch}
                        onChange={(e) => setOperatorGameSearch(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                searchOperatorGameConfig();
                            }
                        }}
                        placeholder="Type at least 2 characters..."
                        style={{
                            flex: 1,
                            height: "44px",
                            padding: "8px 14px",
                            border: "1px solid #ced4da",
                            borderRadius: "6px",
                            fontSize: "18px"
                        }}
                    />

                    <button
                        type="button"
                        onClick={searchOperatorGameConfig}
                        style={{
                            height: "44px",
                            padding: "0 22px",
                            border: "none",
                            borderRadius: "6px",
                            background: "#212529",
                            color: "white",
                            fontSize: "18px",
                            cursor: "pointer"
                        }}
                    >
                        Search
                    </button>
                </div>
            </div>

            <GenericInsertUpdatePage
                inputs={inputs}
                setLoggedIn={props.setLoggedIn}
                endpoint={"campaign-operator-gameconfig/create"}
                pageTitle={"Insert Campaign Game Config"}
                isUpdate={false}
                getEndpoint={"campaign-operator-gameconfig/read"}
                entityName={"Campaign Game Config"}
            />
        </>
    );
}

export default CampaignOperatorGameInsertPage;